<app-loading [isLoading]="isLoading()" message="Loading Search"></app-loading>

<mat-card class="p-3" style="background-color: white;" [hidden]="isLoading()">
  <div class="row">
    <div class="col-6">
      <h4 class="mb-0">Search Roadmaps</h4>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Project Name</mat-label>
        <input matInput [ngModel]="projectName()" (ngModelChange)="projectName.set($event)" (keydown.enter)="onSearchClick()" placeholder="Enter part of project name" maxlength="50">
      </mat-form-field>
    </div>

    <div class="col-md-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Project Number</mat-label>
        <input matInput [ngModel]="jobNumber()" (ngModelChange)="jobNumber.set($event)" (keydown.enter)="onSearchClick()" placeholder="Enter project number" maxlength="10">
      </mat-form-field>
    </div>

    <div class="col-md-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Market Segment</mat-label>
        <mat-select [ngModel]="selectedMarketSegment()" (ngModelChange)="selectedMarketSegment.set($event)">
          <mat-option value="">All</mat-option>
          @for (segment of marketSegments(); track segment) {
            <mat-option [value]="segment">{{ segment }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-md-3">
      <label class="mat-label">Volume Range</label>
      <mat-slider min="0" max="1000000000" step="1000000" class="w-100">
        <input matSliderStartThumb [ngModel]="volumeMin()" (ngModelChange)="volumeMin.set($event)">
        <input matSliderEndThumb [ngModel]="volumeMax()" (ngModelChange)="volumeMax.set($event)">
      </mat-slider>
      <div class="volume-range-labels">
        <span>${{ volumeMin() | number }}</span>
        <span>${{ volumeMax() === 1000000000 ? '1 Billion +' : (volumeMax() | number) }}</span>
      </div>
    </div>

    <div class="col-md-2 d-flex justify-content-center align-items-center">
      <button matButton="filled" (click)="onSearchClick()" [disabled]="isSearchDisabled()" class="mb-4">Search</button>
    </div>
  </div>
  <div class="py-3">
    @if(isSearching()) {
      <mat-progress-bar class="w-100" mode="indeterminate"></mat-progress-bar>
    }
  </div>
  <div class="row">
    <div class="col-12 pt-3">
      @if (hasSearched() && searchResults().length === 0) {
        <div class="no-results-message">
          No Results Found Matching Criteria
        </div>
      }
      @if (hasSearched() && searchResults().length > 0) {
        <table mat-table [dataSource]="dataSource" matSort matSortDisableClear>
        <!-- Project Number -->
        <ng-container matColumnDef="projectNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Project #</th>
          <td mat-cell *matCellDef="let r">{{r.projectNumber}}</td>
        </ng-container>

        <!-- Project Name -->
        <ng-container matColumnDef="projectName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Name</th>
          <td mat-cell *matCellDef="let r">{{r.projectName}}</td>
        </ng-container>

        <!-- Version -->
        <ng-container matColumnDef="version">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Version</th>
          <td mat-cell *matCellDef="let r">{{r.version}}</td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let r">{{r.status.name}}</td>
        </ng-container>

        <!-- Profit Center -->
        <ng-container matColumnDef="profitCenterName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Profit Center</th>
          <td mat-cell *matCellDef="let r">{{r.profitCenter.profitCenterName}}</td>
        </ng-container>

        <!--Market Segment-->
        <ng-container matColumnDef="marketSegment">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Market Segment</th>
          <td mat-cell *matCellDef="let r">{{r.marketSegment}}</td>
        </ng-container>

        <!-- Volume -->
        <ng-container matColumnDef="revenue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Volume</th>
          <td mat-cell *matCellDef="let r">{{r.revenue | currency:'USD':'symbol':'1.0-0'}}</td>
        </ng-container>

        <!--Approved-->
        <ng-container matColumnDef="isApproved">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Approved</th>
          <td mat-cell *matCellDef="let r">{{r.isApproved ? 'Yes' : 'No'}}</td>
        </ng-container>

        <!-- Roadmap Champion -->
        <ng-container matColumnDef="leanChampionName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Roadmap Champion</th>
          <td mat-cell *matCellDef="let r">{{r.leanChampionName}}</td>
        </ng-container>

        <!-- Last Reviewed -->
        <ng-container matColumnDef="lastModifiedOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Reviewed</th>
          <td mat-cell *matCellDef="let r">{{r.lastModifiedOn | date}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRoadmapClick(row)"></tr>
      </table>
      }
    </div>
  </div>
</mat-card>
